import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getYearOptions } from '../../../services/dateServices';
import Api from '../../../../../Global/Modules/Api'

const FETCH_URL = "api/educations/courseunknownadmin"

class OnbekendeCursus extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.emptyForm = this.emptyForm.bind(this)
        this.state = {
            data: {
                institution: '',
                name: '',
                city: '',
                courseType: '',
                level: '',
                yearEnd: '',
                hours: '',
                rounded: ''
            },
            errors: {}
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: [value] } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)
        formData.append('MemberId', this.props.id)
        // Post formData to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                alert("Cursus added")
                window.location.href = '/admin/leden/lid/kennis/' + this.props.id
            })
    }

    emptyForm() {
        // TODO: Show some kind of message so the user knows that something has been created
        Api.print('Emptying form')
        const emptyData = {
            institution: '',
            name: '',
            city: '',
            courseType: '',
            level: '',
            yearEnd: '',
            hours: '',
            rounded: ''
        }

        this.setState({ data: emptyData })
    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="OnbekendeOfIncompanyCursusNaamInstelling">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam bedrijf
                    </Col>

                    <Col sm={6}>
                        <FormControl name="institution" type="text" value={this.state.data.institution} onChange={this.handleChange} required />
                        {Api.showError(errors, "institution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusNaamCursus">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam cursus
                    </Col>

                    <Col sm={6}>
                        <FormControl name="name" type="text" value={this.state.data.name} onChange={this.handleChange} required />
                        {Api.showError(errors, "name")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusTypeCursus">
                    <Col componentClass={ControlLabel} sm={4}>
                        Type cursus
                    </Col>

                    <Col sm={6}>
                        <FormControl name="courseType" value={this.state.data.courseType} onChange={this.handleChange} componentClass="select" required>
                            <option value="">selecteer</option>
                            <option value="technisch">technisch</option>
                            <option value="software">software</option>
                            <option value="aanpalend">aanpalend</option>
                            <option value="management">management</option>
                        </FormControl>
                        {Api.showError(errors, "courseType")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusNiveau">
                    <Col componentClass={ControlLabel} sm={4}>
                        Niveau
                    </Col>

                    <Col sm={6}>
                        <FormControl name="level" type="text" value={this.state.data.level} onChange={this.handleChange} required />
                        {Api.showError(errors, "level")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusAfgerond">
                    <Col componentClass={ControlLabel} sm={4}>
                        Afgerond in
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" value={this.state.data.yearEnd} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "yearEnd")}
                    </Col>
                </FormGroup>
                <FormGroup controlId="OnbekendeOfIncompanyCursusPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>

                    <Col sm={6}>
                        <FormControl name="city" type="text" value={this.state.data.city} onChange={this.handleChange} required />
                        {Api.showError(errors, "city")}
                    </Col>
                </FormGroup>
                <FormGroup controlId="OnbekendeOfIncompanyCursusAantalLesuren">
                    <Col componentClass={ControlLabel} sm={4}>
                        Aantal lesuren (excl. pauzes e.d.)
                    </Col>

                    <Col sm={6}>
                        <FormControl name="hours" type="text" value={this.state.data.hours} onChange={this.handleChange} required />
                        {Api.showError(errors, "hours")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusAfgerondMetToets">
                    <Col componentClass={ControlLabel} sm={4}>
                        Afgerond met toets
                    </Col>

                    <Col sm={6}>
                        <FormControl name="rounded" componentClass="select" value={this.state.data.rounded} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            <option value="ja">ja</option>
                            <option value="nee">nee</option>
                        </FormControl>
                        {Api.showError(errors, "rounded")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusDiploma">
                    <Col componentClass={ControlLabel} sm={4}>
                        Diploma
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default OnbekendeCursus;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/OnbekendeCursus.js